import '@polymer/paper-listbox/paper-listbox';
import '@polymer/paper-item/paper-item';
import './neb-nav-item';
import '../../../../../src/components/misc/neb-icon';

import { LitElement, html, css } from 'lit';

import { baseStyles } from '../../../../neb-styles/neb-styles';
import {
  CSS_FONT_SIZE_HEADER,
  CSS_FONT_FAMILY,
  CSS_SPACING,
  CSS_COLOR_HIGHLIGHT,
  CSS_COLOR_WHITE,
  CSS_FONT_SIZE_BODY,
  CSS_COLOR_GREY_1,
  CSS_BORDER_GREY_2,
  CSS_COLOR_GREY_4,
  CSS_COLOR_BLACK,
} from '../../../../neb-styles/neb-variables';

export const ELEMENTS = {
  userNavTitle: {
    id: 'nav-title',
  },
  userMenu: {
    id: 'user-menu',
  },
  appointmentsItem: {
    id: 'appointments-item',
  },
  paymentsItem: {
    id: 'payments-item',
  },
  logoutItem: {
    id: 'logout-item',
  },
  closeIcon: {
    id: 'close-icon',
  },
};

class NebUserNav extends LitElement {
  static get properties() {
    return {
      __selected: String,

      title: String,
      showMyPayments: Boolean,
      layout: {
        type: String,
        reflect: true,
      },
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: flex;
          flex-direction: column;
          color: ${CSS_COLOR_BLACK};
        }

        .title-user-nav {
          font-size: ${CSS_FONT_SIZE_HEADER};
          font-family: ${CSS_FONT_FAMILY};
          margin-left: 32px;
          margin-bottom: ${CSS_SPACING};
          color: ${CSS_COLOR_HIGHLIGHT};
          font-weight: bold;
        }

        .menu-user {
          padding: 5px 0;
        }

        .menu-item {
          font-size: ${CSS_FONT_SIZE_BODY};
          font-family: ${CSS_FONT_FAMILY};
          display: flex;
          cursor: pointer;
          padding: 0 ${CSS_SPACING};
        }

        .menu-item:focus::before {
          background-color: ${CSS_COLOR_WHITE};
        }

        .menu-item[selected] {
          color: ${CSS_COLOR_WHITE};
          background-color: ${CSS_COLOR_HIGHLIGHT};
        }

        :host(:not([layout='small'])) .menu-item {
          min-height: 34px;
        }

        :host([layout='small']) .menu-user {
          text-indent: 22px;
        }

        :host([layout='small']) .menu-item {
          padding-top: 7px;
          padding-bottom: 6px;
        }

        .menu-item:not([selected]):hover {
          background-color: ${CSS_COLOR_GREY_4};
        }

        .neb-separator-border {
          border-top: ${CSS_BORDER_GREY_2};
        }

        .neb-separator-border:last-of-type {
          border-bottom: ${CSS_BORDER_GREY_2};
        }

        .neb-nav-item {
          margin: auto;
        }

        .icon {
          fill: ${CSS_COLOR_GREY_1};
          cursor: pointer;
          height: 24px;
          width: 24px;
        }

        .container-icon {
          display: flex;
          justify-content: flex-end;
          margin: 18px 18px 25px 0;
        }
      `,
    ];
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__selected = '';
    this.layout = '';
    this.title = '';
    this.showMyPayments = false;

    this.onNavigateToMyAppointments = () => {};

    this.onNavigateToMyPayments = () => {};

    this.onClose = () => {};

    this.onLogout = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      isNavItemSelected: (nav, selectedNav) =>
        !!(selectedNav && selectedNav === nav),
      openMyAppointments: () => {
        this.__selected = 'myAppointments';
        this.onNavigateToMyAppointments();
      },
      openMyPayments: () => {
        this.__selected = 'myPayments';
        this.onNavigateToMyPayments();
      },
      onLogout: _e => {
        this.__selected = 'logout';
        this.onLogout();
      },
      close: () => {
        this.onClose();
      },
    };
  }

  render() {
    return html`
      ${this.layout === 'small'
        ? html`
            <div class="container-icon">
              <neb-icon
                id="${ELEMENTS.closeIcon.id}"
                class="icon"
                icon="neb:close"
                @click="${this.__handlers.close}"
              ></neb-icon>
            </div>
            <div id="${ELEMENTS.userNavTitle.id}" class="title-user-nav">
              ${this.title}
            </div>
          `
        : ''}

      <paper-listbox
        id="${ELEMENTS.userMenu.id}"
        role="menu"
        class="menu-user"
        selected="${this.__selected}"
        attr-for-selected="nav"
        selected-attribute="selected"
      >
        <paper-item
          id="${ELEMENTS.appointmentsItem.id}"
          nav="myAppointments"
          class="menu-item ${this.layout === 'small'
            ? 'neb-separator-border'
            : ''}"
          @click="${this.__handlers.openMyAppointments}"
        >
          <neb-nav-item
            class="neb-nav-item"
            label="My Appointments"
            selected="${this.__handlers.isNavItemSelected(
              'myAppointments',
              this.__selected,
            )}"
          ></neb-nav-item>
        </paper-item>

        ${this.showMyPayments
          ? html`
              <paper-item
                id="${ELEMENTS.paymentsItem.id}"
                nav="myPayments"
                class="menu-item ${this.layout === 'small'
                  ? 'neb-separator-border'
                  : ''}"
                @click="${this.__handlers.openMyPayments}"
              >
                <neb-nav-item
                  class="neb-nav-item"
                  label="My Payments"
                  selected="${this.__handlers.isNavItemSelected(
                    'myPayments',
                    this.__selected,
                  )}"
                ></neb-nav-item>
              </paper-item>
            `
          : ''}

        <paper-item
          id="${ELEMENTS.logoutItem.id}"
          nav="logout"
          class="menu-item ${this.layout === 'small'
            ? 'neb-separator-border'
            : ''}"
          @click="${this.__handlers.onLogout}"
        >
          <neb-nav-item
            class="neb-nav-item"
            label="Logout"
            selected="${this.__handlers.isNavItemSelected(
              'logout',
              this.__selected,
            )}"
          ></neb-nav-item>
        </paper-item>
      </paper-listbox>
    `;
  }
}

customElements.define('neb-user-nav', NebUserNav);
